module.exports = __webpack_public_path__ + "media/images/flags/fr-426cf2e4c72a56208cd70a324922e227.png";